export default Object.freeze({
  house: 1,
  land: 2,
  car: 3,
  boat: 4,
  plane: 5,
});
